<template>
  <div>
    <el-form ref="form" :model="form" label-width="180px" style="width: 90%">
      <div style="width: 45%; float: left">
        <el-form-item label="Contract Company">
          <el-input v-model="form.customerName"/>
        </el-form-item>
        <el-form-item label="Project Name">
          <el-input v-model="form.projectName"/>
        </el-form-item>
        <el-form-item label="Contact Name">
          <el-input v-model="form.contact"/>
        </el-form-item>
        <el-form-item label="Prepared By">
          <el-input v-model="form.creatorName"/>
        </el-form-item>
      </div>
      <div style="width: 45%; float: left">
        <el-form-item label="Date">
          <el-col :span="11">
            <el-date-picker v-model="form.orderDate" type="date" placeholder="Choose Date"/>
          </el-col>
        </el-form-item>
        <el-form-item label="Expected Delivery Date">
          <el-col :span="11">
            <el-date-picker v-model="form.planDeliveryDate" type="date" placeholder="Choose Date"/>
          </el-col>
        </el-form-item>
        <el-form-item label="Order No.">
          <el-input v-model="form.clientContractNO"/>
        </el-form-item>
        <el-form-item label="Delivery port">
          <el-input v-model="form.deliveryPort"/>
        </el-form-item>
      </div>
      <div class="hstitle">Attentions</div>
      <div>
        <el-form-item label="项目类型">
          <el-radio-group v-model="form.ProjectType">
            <el-radio label="国内项目" @click.native.prevent="radioClick('国内项目', 'ProjectType')"/>
            <el-radio label="海外项目" @click.native.prevent="radioClick('海外项目', 'ProjectType')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="插座">
          <el-radio-group v-model="form.Socket">
            <el-radio label="通用插座" @click.native.prevent="radioClick('通用插座', 'Socket')"/>
            <el-radio label="EU插座" @click.native.prevent="radioClick('EU插座', 'Socket')"/>
            <el-radio label="英制插座" @click.native.prevent="radioClick('英制插座', 'Socket')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="折叠护栏开关">
          <el-switch v-model="form.FBSwitch" label="折叠护栏开关"/>
        </el-form-item>
        <el-form-item label="消防盒">
          <el-radio-group v-model="form.FireBox">
            <el-radio label="不需要消防盒" @click.native.prevent="radioClick('不需要消防盒', 'FireBox')"/>
            <el-radio label="FS C300消防盒" @click.native.prevent="radioClick('FS C300消防盒', 'FireBox')"/>
            <el-radio label="需要透明玻璃的消防盒" @click.native.prevent="radioClick('需要透明玻璃的消防盒', 'FireBox')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="消防盒材质">
          <el-radio-group v-model="form.MTFireBox">
            <el-radio label="钛黑发纹不锈钢" @click.native.prevent="radioClick('钛黑发纹不锈钢', 'MTFireBox')"/>
            <el-radio label="古铜发纹不锈钢" @click.native.prevent="radioClick('古铜发纹不锈钢', 'MTFireBox')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="ARD">
          <el-radio-group v-model="form.ATARD">
            <el-radio label="ARD HAA1001JK1(无电池)" style="line-height: 28px; margin-bottom: 5px" @click.native.prevent="radioClick('ARD HAA1001JK1(无电池)', 'ATARD')"/>
            <el-radio label="ARD HAA1001JJ1（有电池），发货前电池需拆除，单独放置在一个箱子内" style="line-height: 28px; margin-bottom: 5px" @click.native.prevent="radioClick('ARD HAA1001JJ1（有电池），发货前电池需拆除，单独放置在一个箱子内', 'ATARD')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Pizzato开关">
          <el-switch v-model="form.PztSwitch" label="Pizzato开关都要预接线" active-text="Pizzato开关需要预接线"/>
        </el-form-item>
        <el-form-item label="门机线">
          <el-checkbox-group v-model="form.DMLine">
            <el-checkbox label="门机线T1,T2上需预接速普端子" style="width: 40%"/>
            <el-checkbox label="西子门机，门机线T1,T2上需预接西子门机端子" style="width: 40%"/>
            <el-checkbox label="Door machine connectors need to be pre-connected on T1,T2 branch cable"/>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="限速器端子">
          <el-radio-group v-model="form.SGTerminal">
            <el-radio label="限速器MS，74要压端子，连接限速器线长度改为4米" @click.native.prevent="radioClick('限速器MS，74要压端子，连接限速器线长度改为4米', 'SGTerminal')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开关位置">
          <el-radio-group v-model="form.SwitchPosition">
            <el-radio label="减速开关和极限开关需要移动到轿顶，和ATLAS GIGAS同样设计！！" @click.native.prevent="radioClick('减速开关和极限开关需要移动到轿顶，和ATLAS GIGAS同样设计！！', 'SwitchPosition')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="线槽">
          <el-radio-group v-model="form.Trunking">
            <el-radio label="无需提供塑料线槽，客户自备金属线槽" @click.native.prevent="radioClick('无需提供塑料线槽，客户自备金属线槽', 'Trunking')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="消防模式">
          <el-radio-group v-model="form.FireMode">
            <el-radio label="需要设置消防模式" style="line-height: 28px; margin-bottom: 5px" @click.native.prevent="radioClick('需要设置消防模式', 'FireMode')"/>
            <el-radio label="需要澳洲消防程序" style="line-height: 28px; margin-bottom: 5px" @click.native.prevent="radioClick('需要澳洲消防程序', 'FireMode')"/>
            <el-radio label="需要设置2个消防楼层，G楼为主消防楼层，1楼为第二消防楼层" style="line-height: 28px; margin-bottom: 5px" @click.native.prevent="radioClick('需要设置2个消防楼层，G楼为主消防楼层，1楼为第二消防楼层', 'FireMode')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="特别选项">
          <el-checkbox-group v-model="form.ATSPOptions">
            <el-checkbox label="LED井道灯" style="width: 20%"/>
            <el-checkbox label="新井道灯（如果可用）" style="width: 20%"/>
            <el-checkbox label="主机电压380Vac" style="width: 20%"/>
            <el-checkbox label="半自动门，无轿门" style="width: 20%"/>
            <el-checkbox label="作家用梯使用,不验收!" style="width: 40%"/>
            <el-checkbox label="随行电缆长度安新非标计算" style="width: 40%"/>
            <el-checkbox label="所有空气断路器必须是施耐德品牌！！" style="width: 40%"/>
            <el-checkbox label="科莱曼提供 10724364 DEVICE 5HV-021  (TRIPHONIE) 2pcs" style="width: 40%"/>
            <el-checkbox label="限速器测试和UPS电动松闸回路要重新设计" style="width: 40%"/>
            <el-checkbox label="轿顶需要提供一个额外的12Vdc应急电源，作为轿厢照明应急电源，所有EN81.20订单都需要！！"/>
            <el-checkbox class="overwidth" label="注意，此订单任何LOGO都需要用客户LOGO,不能体现任何KLEEMANN LOGO，如果有无法替换的情况，建议删除LOGO,包括外包装，装箱单。"/>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div style="clear:both; height: 20px;"/>
      <div class="hstitle">Lift Specifications</div>
      <div class="horizontal-2">
        <el-form-item label="Lift Speed">
          <el-input v-model="form.LiftSpeed" style="width: 150px">
            <template slot="append">M/SEC</template>
          </el-input>
        </el-form-item>
        <el-form-item label="Lift Load">
          <el-input v-model="form.LiftLoad" style="width: 150px">
            <template slot="append"> KG </template>
          </el-input>
        </el-form-item>
        <el-form-item label="No. of Lift">
          <el-input v-model="form.NoOfLift"/>
        </el-form-item>
        <el-form-item label="实际运行速度">
          <el-input v-model="form.ARSpeed"/>
        </el-form-item>
      </div>
      <div class="horizontal-4">
        <el-form-item label="Number of Lifts">
          <el-input v-model="form.NBLifts"/>
        </el-form-item>
        <el-form-item label="No. of Floors">
          <el-input v-model="form.NBFloors"/>
        </el-form-item>
        <el-form-item label="Number of Car Entrances">
          <el-input v-model="form.NBCarEntrances"/>
        </el-form-item>
        <el-form-item label="No. of Openings">
          <el-input v-model="form.NBOpenings"/>
        </el-form-item>
      </div>
      <div class="horizontal-2">
        <div style="clear: both; font-size: 13px; margin-left: 50px;">Floor Markings (请填入楼层数字, 多个数字以“,”隔开)</div>
        <el-form-item label="开前门">
          <el-input v-model="form.FrontOpening"/>
        </el-form-item>
        <el-form-item label="开后门">
          <el-input v-model="form.RearOpening"/>
        </el-form-item>
        <el-form-item label="前后双开门">
          <el-input v-model="form.AllOpening"/>
        </el-form-item>
        <el-form-item label="Main Lobby Marking">
          <el-input v-model="form.MLMarking"/>
        </el-form-item>
      </div>
      <div style="clear:both;"/>
      <div>
        <el-form-item label="Main Power Supply">
          <el-radio-group v-model="form.MPSupply">
            <el-radio label="1x230 V AC" @click.native.prevent="radioClick('1x230 V AC', 'MPSupply')"/>
            <el-radio label="3x380 V AC + 1x220 V AC" @click.native.prevent="radioClick('3x380 V AC + 1x220 V AC', 'MPSupply')"/>
            <el-radio label="3x415 V AC + 1x240 V AC" @click.native.prevent="radioClick('3x415 V AC + 1x240 V AC', 'MPSupply')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="horizontal-3">
        <el-form-item v-model="form.PhaseInput" label="Phase input">
          <el-input/>
        </el-form-item>
        <el-form-item v-model="form.Hertz" label="Hertz">
          <el-input/>
        </el-form-item>
        <el-form-item v-model="form.InputWires" label="Input wires  L1,L2,L3,N,PE">
          <el-input/>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="电梯选项">
          <el-checkbox-group v-model="form.LSOptions">
            <el-checkbox label="请提供，高耐压主板"/>
            <el-checkbox label="需要二次门锁回路"/>
            <el-checkbox label="控制柜内需要提供BMS干触点信号：电梯消防信号输出，主电源信号输出，正常/故障信号输出"/>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div class="hstitle">Controller</div>
      <div class="horizontal-2">
        <el-form-item v-model="form.FQChanger" label="变频器">
          <el-input/>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="Type of System">
          <el-radio-group v-model="form.TypeofSystem">
            <el-radio label="Serial Communication！" @click.native.prevent="radioClick('Serial Communication！', 'TypeofSystem')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="Type of Group">
          <el-radio-group v-model="form.TypeofGroup">
            <el-radio label="Simplex" @click.native.prevent="radioClick('Simplex', 'TypeofGroup')"/>
            <el-radio label="Duplex" @click.native.prevent="radioClick('Duplex', 'TypeofGroup')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="Type of Control">
          <el-radio-group v-model="form.TypeofControl">
            <el-radio label="Down Collective" @click.native.prevent="radioClick('Down Collective', 'TypeofControl')"/>
            <el-radio label="Full Collective" @click.native.prevent="radioClick('Full Collective', 'TypeofControl')"/>
            <el-radio label="Group Control - No of Lifts." @click.native.prevent="radioClick('Group Control - No of Lifts.', 'TypeofControl')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="地震传感器" style="float:left;">
          <el-radio-group v-model="form.SeismicSensor">
            <el-radio label="需要地震传感器" @click.native.prevent="radioClick('需要地震传感器', 'SeismicSensor')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-model="form.SSLength" label="地震传感器配线长度" style="float:left;">
          <el-input>
            <template slot="append">M</template>
          </el-input>
        </el-form-item>
      </div>
      <div style="clear:both;"/>
      <div>
        <el-form-item label="控制柜选项">
          <el-checkbox-group v-model="form.CCOptions">
            <el-checkbox label="静音接触器" style="width: 20%"/>
            <el-checkbox label="新维保装置" style="width: 20%"/>
            <el-checkbox label="新款底坑维保装置" style="width: 20%"/>
            <el-checkbox label="EN 81.1" style="width: 20%"/>
            <el-checkbox label="EN 81.20" style="width: 20%"/>
            <el-checkbox label="380Vac 3相输入" style="width: 20%"/>
            <el-checkbox label="200VG分体控制柜" style="width: 20%"/>
            <el-checkbox label="400VG分体控制柜" style="width: 20%"/>
            <el-checkbox label="需要能量回收系统！" style="width: 20%"/>
            <el-checkbox label="Inox Satin finishing" style="width: 20%"/>
            <el-checkbox label="Kleemann specifications" style="width: 20%"/>
            <el-checkbox label="需要SSCB,SSBB缓冲器安全开关连接线！！" style="width: 40%"/>
            <el-checkbox label="Small control cabinet / stainless steel satin finishing" style="width: 40%"/>
            <el-checkbox label="需要UCMP/A3功能,(需要再平层) " style="width: 40%"/>
            <el-checkbox label="厅/轿门锁短接回路 (无需声光报警装置)" style="width: 40%"/>
            <el-checkbox label="底坑需要增加爬梯安全开关SSRL" style="width: 40%"/>
            <el-checkbox label="控制柜通风孔在柜体后面，不能有明显焊点！！" style="width: 40%"/>
            <el-checkbox label="光幕需要接进安全回路" style="width: 40%"/>
            <el-checkbox label="Auto Transformer  EMA225C1(10KVA) needed!!" style="width: 40%"/>
            <el-checkbox label="底坑检修复位按钮在控制柜内" style="width: 40%"/>
            <el-checkbox label="轿厢有逃生窗，安全回路需要增加一个安全触点连接逃生窗电气开关！" style="width: 40%"/>
            <el-checkbox label="控制柜检修需要短接松绳检测装置" style="width: 40%"/>
            <el-checkbox label="有松绳检测装置，请配置FR615安全开关并接好线" style="width: 40%"/>
            <el-checkbox label="Small car top revision box" style="width: 40%"/>
            <el-checkbox label="程序需要NSPE07KN09CN.17， 前后门一起控制时外呼仅开本侧门" style="width: 40%"/>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-model="form.MCDoor" label="Mounting of the cabinet door">
          <el-select placeholder="左侧" style="width: 180px;">
            <el-option label="左侧" value="左侧"/>
            <el-option label="右侧" value="右侧"/>
          </el-select>
        </el-form-item>
      </div>
      <div class="hstitle">Main Motor</div>
      <div>
        <el-form-item v-model="form.MotorModel" label="Motor Model">
          <el-input style="max-width: 50%"/>
        </el-form-item>
        <el-form-item label="Motor Type">
          <el-radio-group v-model="form.MotorType">
            <el-radio label="Sychron motor" @click.native.prevent="radioClick('Sychron motor', 'MotorType')"/>
            <el-radio label="Asychron motor" @click.native.prevent="radioClick('Asychron motor', 'MotorType')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Gear Type">
          <el-radio-group v-model="form.GearType">
            <el-radio label="Gearless machine" @click.native.prevent="radioClick('Gearless machine', 'GearType')"/>
            <el-radio label="Geared machine" @click.native.prevent="radioClick('Geared machine', 'GearType')"/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Cable Type">
          <el-checkbox-group v-model="form.CableType">
            <el-checkbox label="With pre-wired motor power supply cable"/>
            <el-checkbox label="With pre-wired motor thermal resistor TC cable "/>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div class="horizontal-3">
        <el-form-item v-model="form.MotorCapacity" label="Motor capacity">
          <el-input style="width: 150px">
            <template slot="append"> KW</template>
          </el-input>
        </el-form-item>
        <el-form-item v-model="form.Voltage" label="Voltage">
          <el-input style="width: 150px">
            <template slot="append"> V </template>
          </el-input>
        </el-form-item>
      </div>
      <div class="horizontal-3">
        <el-form-item v-model="form.RRSpeed" label="Rated rotation speed">
          <el-input style="width: 150px">
            <template slot="append">RMP</template>
          </el-input>
        </el-form-item>
        <el-form-item v-model="form.RatedCurrent" label="Rated Current">
          <el-input style="width: 150px">
            <template slot="append"> A </template>
          </el-input>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="主机选项">
          <el-checkbox-group v-model="form.MCOptions">
            <el-checkbox label="主机有远程松闸装置"/>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div style="width: 49%; float:left;">
        <div class="hstitle">Motor Brake Data</div>
        <div>
          <el-form-item v-model="form.ACTVoltage" label="Activating Voltage">
            <el-input/>
          </el-form-item>
          <el-form-item v-model="form.HoldVoltage" label="Hold Voltage">
            <el-input/>
          </el-form-item>
        </div>
      </div>
      <div style="width: 49%; float:right;">
        <div class="hstitle">Drive</div>
        <div>
          <el-form-item label="Type of Drive">
            <el-radio-group v-model="form.TypeofDrive">
              <el-radio label="VVVF" @click.native.prevent="radioClick('VVVF', 'TypeofDrive')"/>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
      <div class="hstitle">Speed feedback</div>
      <div>
        <el-form-item label="Speed feedback">
          <el-checkbox-group v-model="form.SPfeedback">
            <el-checkbox label="existing Tacho"/>
            <el-checkbox label="existing motor encoder"/>
            <el-checkbox label="existing encoder on governor"/>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="Encoder Type">
          <el-radio-group v-model="form.EncoderType">
            <el-radio label="Encoder Heidenhein ΕCΝ1313" @click.native.prevent="radioClick('Encoder Heidenhein ΕCΝ1313', 'EncoderType')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="hstitle">Door Drive</div>
      <div>
        <el-form-item v-model="form.BrandofDD" label="Brand of Door Drive">
          <el-input style="max-width: 50%"/>
        </el-form-item>
        <div>
          <el-form-item label="Type">
            <el-radio-group v-model="form.ACType">
              <el-radio label="AC with VVVF Regulator" @click.native.prevent="radioClick('AC with VVVF Regulator', 'ACType')"/>
            </el-radio-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="Door safety">
            <el-radio-group v-model="form.DoorSafety">
              <el-radio label="Light Curtain" @click.native.prevent="radioClick('Light Curtain', 'DoorSafety')"/>
              <el-radio label="Light Ray" @click.native.prevent="radioClick('Light Ray', 'DoorSafety')"/>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="horizontal-3">
          <el-form-item v-model="form.DoorSafetySupply" label="Door safety supply">
            <el-input style="width: 150px">
              <template slot="append"> V AC </template>
            </el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="Mechanical Safety Edge">
            <el-switch v-model="form.MCSafetyEdge"/>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="门机选项">
            <el-checkbox-group v-model="form.PCOptions">
              <el-checkbox label="中分门"/>
              <el-checkbox label="新门机，需要更新门机接线"/>
              <el-checkbox label="不需要提供二次门锁开关，由福马特提供"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </div>
      <div class="hstitle">Information Device</div>
      <div>
        <el-form-item label="Arrival gong">
          <el-radio-group v-model="form.ArrivalGong">
            <el-radio label="on top of the car" @click.native.prevent="radioClick('on top of the car', 'ArrivalGong')"/>
            <el-radio label="at every floor" @click.native.prevent="radioClick('at every floor', 'ArrivalGong')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="Intercom">
          <el-checkbox-group v-model="form.Intercom">
            <el-checkbox label="4 stations"/>
            <el-checkbox label="5 stations"/>
            <el-checkbox label="20M cable needed"/>
            <el-checkbox label="需要内部对讲"/>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="Voice announcement">
          <el-radio-group v-model="form.VoiceANNC">
            <el-radio label="English" @click.native.prevent="radioClick('English', 'VoiceANNC')"/>
            <el-radio label="Spanish" @click.native.prevent="radioClick('Spanish', 'VoiceANNC')"/>
            <el-radio label="泰语" @click.native.prevent="radioClick('泰语', 'VoiceANNC')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="Automatic evacuation">
          <el-radio-group v-model="form.AUTOEvacuation">
            <el-radio label="New UPS will be sent by KLEEMANN, ONLY UPS cable needed" @click.native.prevent="radioClick('New UPS will be sent by KLEEMANN, ONLY UPS cable needed', 'AUTOEvacuation')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="ARD">
          <el-checkbox-group v-model="form.IFARD">
            <el-checkbox label="ARD HAA1001JJ1(无电池)"/>
            <el-checkbox label="ARD由KLEEMANN提供，STEP提供ARD连接控制柜的动力线缆"/>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div class="hstitle">Shaft Wiring</div>
      <div class="sw_center">
        <el-form-item label="Height from controller to top floor" label-width="350px">
          <el-input v-model="form.HFCONTToTFloor"/>
        </el-form-item>
      </div>
      <div class="sw_center">
        <el-form-item label="Total Travel of Lift" label-width="350px">
          <el-input v-model="form.TTravelLift">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="sw_center">
        <el-form-item label="The distance from Shaft to Controller" label-width="350px">
          <el-input v-model="form.DistanceFSToCONT">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="sw_center">
        <el-form-item label="The distance from the Controller to the motor/brake" label-width="350px">
          <el-input v-model="form.DistanceFCToMB">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="sw_center">
        <el-form-item label="Overhead Height" label-width="350px">
          <el-input v-model="form.OverheadHeight">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="sw_center">
        <el-form-item label="Pit Depth" label-width="350px">
          <el-input v-model="form.PitDepth">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="sw_center">
        <el-form-item label="The distance from hall call to shaft" label-width="350px">
          <el-input v-model="form.DistFHCToShaft">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="sw_center">
        <el-form-item label="The distance from hall button to floor indicator" label-width="350px">
          <el-input v-model="form.DistFHBToFIndicator"/>
        </el-form-item>
      </div>
      <div v-for="(item,index) in form.floors" :key="index">
        <div class="sw_center sw_float">
          <el-form-item
              label="Floor to Floor Height"
              label-width="350px">
            <el-input v-model="item.floorHeight">
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="sw_float">
          <div style="float: left; width: 30px; line-height: 30px;margin-left: 15px;">X</div>
          <div style="float: left; width: 100px;">
            <el-form-item label-width="0px">
              <el-input v-model="item.floorLevels">
                <template slot="append">层</template>
              </el-input>
            </el-form-item>
          </div>
          <div style="float: left; width: 50px;">
            <el-form-item label-width="5px">
              <el-button icon="el-icon-plus" @click="addItem"/>
            </el-form-item>
          </div>
          <div style="float: left; width: 50px;">
            <el-form-item label-width="0px">
              <el-button v-if="form.floors.length > 1" icon="el-icon-minus" @click="deleteItem(item,index)"/>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="sw_center sw_float">
        <el-form-item label="Shaft width" label-width="350px">
          <el-input v-model="form.ShaftWidth">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="sw_center sw_float">
        <el-form-item label="Shaft depth" label-width="350px">
          <el-input v-model="form.ShaftDepth">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="sw_center sw_float">
        <el-form-item label="Duplex cable并联线" label-width="350px">
          <el-input v-model="form.DPXCBPline">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
      </div>
      <div style="clear:both;">
        <el-form-item label="井道线缆选项">
          <el-checkbox-group v-model="form.WCOptions">
            <el-checkbox label="应急拨号线缆需要屏蔽" style="width: 40%"/>
            <el-checkbox label="Extra travel Cable CAT5e" style="width: 40%"/>
            <el-checkbox label="随行电缆内需要2组电话线" style="width: 40%"/>
            <el-checkbox label="In traveling cable provide 4PCS CAT-7 cable" style="width: 40%"/>
            <el-checkbox label="随行电缆内需要配置CAT6（屏蔽） 电缆" style="width: 40%"/>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div class="hstitle">
        Car Operation Panel（1）
        <div style="float: right; margin-top: 3px">
          <el-form-item>
            <el-button type="normal" @click="showCOP2 = !showCOP2">
              {{showCOP2 ? '删除副板':'增加副板'}}
            </el-button>
          </el-form-item>
        </div>
      </div>
      <div class="COP1">
        <div>
          <el-form-item label="">
            <el-radio-group v-model="form.BSTCOP">
              <el-radio label="COP由BST提供，STEP提供相关电子部件" label-width="350px" @click.native.prevent="radioClick('COP由BST提供，STEP提供相关电子部件', 'BSTCOP')"/>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="ww2">
          <el-form-item label="COP Model">
            <el-checkbox-group v-model="form.COPModel">
              <el-checkbox label="KCH SM BA SP  (Surface mounted COP) " style="width: 100%"/>
              <el-checkbox label="KCH LCD COP" style="width: 100%"/>
              <el-checkbox label="KCH C300 COP" style="width: 100%"/>
              <el-checkbox label="KCH 1000 SP Horizontal COP" style="width: 100%"/>
              <el-checkbox label="KCH TFT COP" style="width: 100%"/>
              <el-checkbox label="KCH ( COP 410)" style="width: 100%"/>
              <el-checkbox label="KCH TFT (COP410)" style="width: 100%"/>
              <el-checkbox label="KCH TSC Black COP" style="width: 100%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="ww2">
          <el-form-item label="COP Button Model">
            <el-radio-group v-model="form.COPBtnModel">
              <el-radio label="Blue line buttons KLH42R" class="radio100" @click.native.prevent="radioClick('Blue line buttons KLH42R', 'COPBtnModel')"/>
              <el-radio label="Blue EB960 button" class="radio100" @click.native.prevent="radioClick('Blue EB960 button', 'COPBtnModel')"/>
              <el-radio label="Bicolor White-Blue  button HA2300" class="radio100" @click.native.prevent="radioClick('Bicolor White-Blue  button HA2300', 'COPBtnModel')"/>
              <el-radio label="Touch sensitive Square Blue button" class="radio100" @click.native.prevent="radioClick('Touch sensitive Square Blue button', 'COPBtnModel')"/>
              <el-radio label="White EB960 button(白光EB960按钮)" class="radio100" @click.native.prevent="radioClick('White EB960 button(白光EB960按钮)', 'COPBtnModel')"/>
              <el-radio label="blue line buttons KLH42Q（方按钮）" class="radio100" @click.native.prevent="radioClick('blue line buttons KLH42Q（方按钮）', 'COPBtnModel')"/>
              <el-radio label="Blue EB218 button" class="radio100" @click.native.prevent="radioClick('Blue EB218 button', 'COPBtnModel')"/>
              <el-radio label="Blue EB680 button" class="radio100" @click.native.prevent="radioClick('Blue EB680 button', 'COPBtnModel')"/>
            </el-radio-group>
          </el-form-item>
        </div>
        <div style="clear:both;"/>
        <div>
          <el-form-item label="COP Surface">
            <el-checkbox-group v-model="form.COPSurface">
              <el-checkbox label="Stainless Steel Satin/发纹不锈钢" style="width: 40%"/>
              <el-checkbox label="Stainless Steel Mirror/镜面不锈钢" style="width: 40%"/>
              <el-checkbox label="Black glass panel-Touch sensitive" style="width: 40%"/>
              <el-checkbox label="Stainless Steel Rose Gold Mirror/玫瑰金镜面不锈钢" style="width: 40%"/>
              <el-checkbox label="Stainless Steel Gold Mirror/钛金镜面不锈钢"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div style="float:left;">
          <el-form-item label="COP Indicator">
            <el-radio-group v-model="form.COPIndicator">
              <el-radio label="Dot-matrix indicator" style="width: 120px; float:left; line-height: 35px;" @click.native.prevent="radioClick('Dot-matrix indicator', 'COPIndicator')"/>
              <el-select v-model="form.COPDotmatrix1" placeholder="蓝色点阵VRM" style="width: 200px; float: left" :disabled="form.COPIndicator !=='Dot-matrix indicator'">
                <el-option label="蓝色点阵VRM" value="蓝色点阵VRM"/>
                <el-option label="红色点阵VRM" value="红色点阵VRM"/>
              </el-select>
              <div style="clear:both;"/>
              <el-radio label="LCD indicator" style="width: 120px; float:left; line-height: 35px;" @click.native.prevent="radioClick('LCD indicator', 'COPIndicator')"/>
              <el-select v-model="form.COPLCD1" placeholder="黑底白字SM.04VL16Y" style="width: 200px;float: left" :disabled="form.COPIndicator !=='LCD indicator'">
                <el-option label="蓝底白字SM.04VL16Y" value="蓝底白字SM.04VL16Y"/>
                <el-option label="黑底白字SM.04VL16Y" value="黑底白字SM.04VL16Y"/>
              </el-select>
              <div style="clear:both;"/>
              <el-radio label="TFT Indicator 7" style="width: 200px; line-height: 35px; clear: both" @click.native.prevent="radioClick('TFT Indicator 7', 'COPIndicator')"/>
            </el-radio-group>
          </el-form-item>
        </div>
        <div style="clear:both;"/>
        <div>
          <el-form-item label="声光选项">
            <el-checkbox-group v-model="form.ACOOptions">
              <el-checkbox label="Intercom" style="width: 40%"/>
              <el-checkbox label="Emergency light" style="width: 40%"/>
              <el-checkbox label="Autodialer in COP / Helpy 2w-v" style="width: 40%"/>
              <el-checkbox label="需要电话盒120*300*90mm" style="width: 40%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div style="font-weight: bold; color: #b70000;margin-left: 180px;">* if autodialer choice not ticked, the KLEMAFONE faceplate will be removed</div>
        <div>
          <el-form-item label="COP Faceplate">
            <el-checkbox-group v-model="form.COPFaceplate">
              <el-checkbox label="Chinese & English Faceplate" style="width: 40%"/>
              <el-checkbox label="English only Faceplate" style="width: 40%"/>
              <el-checkbox label="新欧标COP铭牌！" style="width: 40%"/>
              <el-checkbox label="Spanish only Faceplate" style="width: 40%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="COP Nameplate">
            <el-checkbox-group v-model="form.COPNameplate">
              <el-checkbox label="Nameplate to have Serial No." style="width: 40%"/>
              <el-checkbox label="Nameplate to have Client LOGO" style="width: 40%"/>
              <el-checkbox label="Nameplate to have KLEEMANN LOGO" style="width: 40%"/>
              <el-checkbox label="Nameplate to have installer Kleemann Elevators Australia Pty Ltd"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="COP按钮选项">
            <el-checkbox-group v-model="form.COPBtnOptions">
              <el-checkbox label="按钮排布按照新非标" style="width: 40%"/>
              <el-checkbox label="COP button arrangement to be the same as Greece COP" style="width: 40%"/>
              <el-checkbox label="Buttons to have Braille Markings" style="width: 40%"/>
              <el-checkbox label="蜂鸣板SM.09CW/O，配套双色按钮HA2300" style="width: 40%"/>
              <el-checkbox label="需要开门保持，EB960 H按钮" style="width: 40%"/>
              <el-checkbox label="需要开门保持功能，KLH42R H 按钮" style="width: 40%"/>
              <el-checkbox label="禁烟按钮" style="width: 40%"/>
              <el-checkbox label="风扇按钮" style="width: 40%"/>
              <el-checkbox label="警铃按钮" style="width: 40%"/>
              <el-checkbox label="开关门按钮" style="width: 40%"/>
              <el-checkbox label="COP需要加风扇按钮,要加继电器板（kleemann提供），请留好安装螺柱和预接线（新尺寸）" style="width: 40%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="COP钥匙开关选项">
            <el-checkbox-group v-model="form.COPKSOptions">
              <el-checkbox label="需要开门保持功能，KLH42R 钥匙开关" style="width: 40%"/>
              <el-checkbox label="需要消防钥匙开关，KLH42R 钥匙开关" style="width: 40%"/>
              <el-checkbox label="需要DS钥匙开关，作为消防开关" style="width: 40%"/>
              <el-checkbox label="COP需要一个BA530钥匙开关(双位拔出), 控制2 个楼层按钮通断" style="width: 40%"/>
              <el-checkbox label="澳大利亚消防开关" style="width: 40%"/>
              <el-checkbox label="需要独立运行功能, BA530 钥匙开关" style="width: 40%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div style="clear:both;">
          <el-form-item label="COP选项">
            <el-checkbox-group v-model="form.COPOption">
              <el-checkbox label="COP 有蓝线条" label-width="350px" style="width: 40%"/>
              <el-checkbox label="需要提供接副机的线 4*0.75mm，一根轿底（5m），一根轿顶（5m）。" style="width: 40%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </div>
      <div v-if="showCOP2" class="COP2">
        <div class="hstitle">
          Car Operation Panel（2）
        </div>
        <div>
          <el-form-item label="">
            <el-radio-group v-model="form.BSTCOP2">
              <el-radio label="COP由BST提供，STEP提供相关电子部件" label-width="350px" @click.native.prevent="radioClick('COP由BST提供，STEP提供相关电子部件', 'BSTCOP2')"/>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="ww2">
          <el-form-item label="COP Model">
            <el-checkbox-group v-model="form.COPModel2">
              <el-checkbox label="KCH SM BA SP  (Surface mounted COP) " style="width: 100%"/>
              <el-checkbox label="KCH LCD COP" style="width: 100%"/>
              <el-checkbox label="KCH C300 COP" style="width: 100%"/>
              <el-checkbox label="KCH 1000 SP Horizontal COP" style="width: 100%"/>
              <el-checkbox label="KCH TFT COP" style="width: 100%"/>
              <el-checkbox label="KCH ( COP 410)" style="width: 100%"/>
              <el-checkbox label="KCH TFT (COP410)" style="width: 100%"/>
              <el-checkbox label="KCH TSC Black COP" style="width: 100%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="ww2">
          <el-form-item label="COP Button Model">
            <el-radio-group v-model="form.COPBtnModel2">
              <el-radio label="Blue line buttons KLH42R" class="radio100" @click.native.prevent="radioClick('Blue line buttons KLH42R', 'COPBtnModel2')"/>
              <el-radio label="Blue EB960 button" class="radio100" @click.native.prevent="radioClick('Blue EB960 button', 'COPBtnModel2')"/>
              <el-radio label="Bicolor White-Blue  button HA2300" class="radio100" @click.native.prevent="radioClick('Bicolor White-Blue  button HA2300', 'COPBtnModel2')"/>
              <el-radio label="Touch sensitive Square Blue button" class="radio100" @click.native.prevent="radioClick('Touch sensitive Square Blue button', 'COPBtnModel2')"/>
              <el-radio label="White EB960 button(白光EB960按钮)" class="radio100" @click.native.prevent="radioClick('White EB960 button(白光EB960按钮)', 'COPBtnModel2')"/>
              <el-radio label="blue line buttons KLH42Q（方按钮）" class="radio100" @click.native.prevent="radioClick('blue line buttons KLH42Q（方按钮）', 'COPBtnModel2')"/>
              <el-radio label="Blue EB218 button" class="radio100" @click.native.prevent="radioClick('Blue EB218 button', 'COPBtnModel2')"/>
              <el-radio label="Blue EB680 button" class="radio100" @click.native.prevent="radioClick('Blue EB680 button', 'COPBtnModel2')"/>
            </el-radio-group>
          </el-form-item>
        </div>
        <div style="clear:both;"/>
        <div>
          <el-form-item label="COP Surface">
            <el-checkbox-group v-model="form.COPSurface2">
              <el-checkbox label="Stainless Steel Satin/发纹不锈钢" style="width: 40%"/>
              <el-checkbox label="Stainless Steel Mirror/镜面不锈钢" style="width: 40%"/>
              <el-checkbox label="Black glass panel-Touch sensitive" style="width: 40%"/>
              <el-checkbox label="Stainless Steel Rose Gold Mirror/玫瑰金镜面不锈钢" style="width: 40%"/>
              <el-checkbox label="Stainless Steel Gold Mirror/钛金镜面不锈钢"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div style="float:left;">
          <el-form-item label="COP Indicator">
            <el-radio-group v-model="form.COPIndicator2">
              <el-radio label="Dot-matrix indicator" style="width: 120px; float:left; line-height: 35px;" @click.native.prevent="radioClick('Dot-matrix indicator', 'COPIndicator2')"/>
              <el-select v-model="form.COPDotmatrix2" placeholder="蓝色点阵VRM" style="width: 200px; float: left" :disabled="form.COPIndicator2 !=='Dot-matrix indicator'">
                <el-option label="蓝色点阵VRM" value="蓝色点阵VRM"/>
                <el-option label="红色点阵VRM" value="红色点阵VRM"/>
              </el-select>
              <div style="clear:both;"/>
              <el-radio label="LCD indicator" style="width: 120px; float:left; line-height: 35px;" @click.native.prevent="radioClick('LCD indicator', 'COPIndicator2')"/>
              <el-select v-model="form.COPLCD2" placeholder="黑底白字SM.04VL16Y" style="width: 200px;float: left" :disabled="form.COPIndicator2 !=='LCD indicator'">
                <el-option label="蓝底白字SM.04VL16Y" value="蓝底白字SM.04VL16Y"/>
                <el-option label="黑底白字SM.04VL16Y" value="黑底白字SM.04VL16Y"/>
              </el-select>
              <div style="clear:both;"/>
              <el-radio label="TFT Indicator 7" style="width: 200px; line-height: 35px; clear: both" @click.native.prevent="radioClick('TFT Indicator 7', 'COPIndicator2')"/>
            </el-radio-group>
          </el-form-item>
        </div>
        <div style="clear:both;"/>
        <div>
          <el-form-item label="声光选项">
            <el-checkbox-group v-model="form.ACOOptions2">
              <el-checkbox label="Intercom" style="width: 40%"/>
              <el-checkbox label="Emergency light" style="width: 40%"/>
              <el-checkbox label="Autodialer in COP / Helpy 2w-v" style="width: 40%"/>
              <el-checkbox label="需要电话盒120*300*90mm" style="width: 40%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div style="font-weight: bold; color: #b70000;margin-left: 180px;">* if autodialer choice not ticked, the KLEMAFONE faceplate will be removed</div>
        <div>
          <el-form-item label="COP Faceplate">
            <el-checkbox-group v-model="form.COPFaceplate2">
              <el-checkbox label="Chinese & English Faceplate" style="width: 40%"/>
              <el-checkbox label="English only Faceplate" style="width: 40%"/>
              <el-checkbox label="新欧标COP铭牌！" style="width: 40%"/>
              <el-checkbox label="Spanish only Faceplate" style="width: 40%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="COP Nameplate">
            <el-checkbox-group v-model="form.COPNameplate2">
              <el-checkbox label="Nameplate to have Serial No." style="width: 40%"/>
              <el-checkbox label="Nameplate to have Client LOGO" style="width: 40%"/>
              <el-checkbox label="Nameplate to have KLEEMANN LOGO" style="width: 40%"/>
              <el-checkbox label="Nameplate to have installer Kleemann Elevators Australia Pty Ltd"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="COP按钮选项">
            <el-checkbox-group v-model="form.COPBtnOptions2">
              <el-checkbox label="按钮排布按照新非标" style="width: 40%"/>
              <el-checkbox label="COP button arrangement to be the same as Greece COP" style="width: 40%"/>
              <el-checkbox label="Buttons to have Braille Markings" style="width: 40%"/>
              <el-checkbox label="蜂鸣板SM.09CW/O，配套双色按钮HA2300" style="width: 40%"/>
              <el-checkbox label="需要开门保持，EB960 H按钮" style="width: 40%"/>
              <el-checkbox label="需要开门保持功能，KLH42R H 按钮" style="width: 40%"/>
              <el-checkbox label="禁烟按钮" style="width: 40%"/>
              <el-checkbox label="风扇按钮" style="width: 40%"/>
              <el-checkbox label="警铃按钮" style="width: 40%"/>
              <el-checkbox label="开关门按钮" style="width: 40%"/>
              <el-checkbox label="COP需要加风扇按钮,要加继电器板（kleemann提供），请留好安装螺柱和预接线（新尺寸）" style="width: 40%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="COP钥匙开关选项">
            <el-checkbox-group v-model="form.COPKSOptions2">
              <el-checkbox label="需要开门保持功能，KLH42R 钥匙开关" style="width: 40%"/>
              <el-checkbox label="需要消防钥匙开关，KLH42R 钥匙开关" style="width: 40%"/>
              <el-checkbox label="需要DS钥匙开关，作为消防开关" style="width: 40%"/>
              <el-checkbox label="COP需要一个BA530钥匙开关(双位拔出), 控制2 个楼层按钮通断" style="width: 40%"/>
              <el-checkbox label="澳大利亚消防开关" style="width: 40%"/>
              <el-checkbox label="需要独立运行功能, BA530 钥匙开关" style="width: 40%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div style="clear:both;">
          <el-form-item label="COP选项">
            <el-checkbox-group v-model="form.COPOption2">
              <el-checkbox label="COP 有蓝线条" label-width="350px" style="width: 40%"/>
              <el-checkbox label="需要提供接副机的线 4*0.75mm，一根轿底（5m），一根轿顶（5m）。" style="width: 40%"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </div>
      <div class="hstitle">Landing Operation Panels</div>
      <div>
        <el-form-item label="LOP Supplier">
          <el-radio-group v-model="form.LOPSupplier">
            <el-radio label="LOP由BST提供，STEP提供相关电子部件" @click.native.prevent="radioClick('LOP由BST提供，STEP提供相关电子部件', 'LOPSupplier')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="ww2">
        <el-form-item label="LOP Model">
          <el-radio-group v-model="form.LOPModel">
            <el-radio label="Door post LOP" class="radio100" @click.native.prevent="radioClick('Door post LOP', 'LOPModel')"/>
            <el-radio label="LCH LCD LOP" class="radio100" @click.native.prevent="radioClick('LCH LCD LOP', 'LOPModel')"/>
            <el-radio label="LCH C300 LOP" class="radio100" @click.native.prevent="radioClick('LCH C300 LOP', 'LOPModel')"/>
            <el-radio label="LCH TFT LOP" class="radio100" @click.native.prevent="radioClick('LCH TFT LOP', 'LOPModel')"/>
            <el-radio label="LCH  (EH130) LOP" class="radio100" @click.native.prevent="radioClick('LCH  (EH130) LOP', 'LOPModel')"/>
            <el-radio label="LCH TSL 102 LOP" class="radio100" @click.native.prevent="radioClick('LCH TSL 102 LOP', 'LOPModel')"/>
            <el-radio label="LCH SM2 LOP" class="radio100" @click.native.prevent="radioClick('LCH SM2 LOP', 'LOPModel')"/>
            <el-radio label="LCH C341 LOP" class="radio100" @click.native.prevent="radioClick('LCH C341 LOP', 'LOPModel')"/>
            <el-radio label="LCH Duplex version  (并联版EH130)" class="radio100" @click.native.prevent="radioClick('LCH Duplex version  (并联版EH130)', 'LOPModel')"/>
            <el-radio label="AKL-AUS LOP" class="radio100" @click.native.prevent="radioClick('AKL-AUS LOP', 'LOPModel')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="ww2">
        <el-form-item label="LOP Button Model">
          <el-radio-group v-model="form.LOPBtnModel">
            <el-radio label="Blue line buttons KLH42R" class="radio100" @click.native.prevent="radioClick('Blue line buttons KLH42R', 'LOPBtnModel')"/>
            <el-radio label="Blue EB960 button" class="radio100" @click.native.prevent="radioClick('Blue EB960 button', 'LOPBtnModel')"/>
            <el-radio label="Bicolor White-Blue  button HA2300" class="radio100" @click.native.prevent="radioClick('Bicolor White-Blue  button HA2300', 'LOPBtnModel')"/>
            <el-radio label="Touch sensitive Square Blue button" class="radio100" @click.native.prevent="radioClick('Touch sensitive Square Blue button', 'LOPBtnModel')"/>
            <el-radio label="White EB960 button(白光EB960按钮)" class="radio100" @click.native.prevent="radioClick('White EB960 button(白光EB960按钮)', 'LOPBtnModel')"/>
            <el-radio label="blue line buttons KLH42Q（方按钮）" class="radio100" @click.native.prevent="radioClick('blue line buttons KLH42Q（方按钮）', 'LOPBtnModel')"/>
            <el-radio label="Blue PB36 Button" class="radio100" @click.native.prevent="radioClick('Blue PB36 Button', 'LOPBtnModel')"/>
            <el-radio label="Blue EB218 button" class="radio100" @click.native.prevent="radioClick('Blue EB218 button', 'LOPBtnModel')"/>
            <el-radio label="Blue EB680 button" class="radio100" @click.native.prevent="radioClick('Blue EB680 button', 'LOPBtnModel')"/>
          </el-radio-group>
        </el-form-item>
      </div>
      <div style="clear:both;">
        <el-form-item label="LOP Surface">
          <el-checkbox-group v-model="form.LOPSurface">
            <el-checkbox label="Stainless Steel Satin/发纹不锈钢" style="width: 40%"/>
            <el-checkbox label="Stainless Steel Mirror/镜面不锈钢" style="width: 40%"/>
            <el-checkbox label="Stainless Steel Bronze Satin/古铜发纹不锈钢" style="width: 40%"/>
            <el-checkbox label="Stainless Steel Rose Gold Mirror/玫瑰金镜面不锈钢" style="width: 40%"/>
            <el-checkbox label="Black glass panel-Touch sensitive" style="width: 40%"/>
            <el-checkbox label="Stainless Steel Gold Mirror/钛金镜面不锈钢" style="width: 40%"/>
            <el-checkbox label="Stainless Steel Black Satin/ 钛黑发纹不锈钢 " style="width: 40%"/>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="">
          <el-input v-model="form.NoLOPs" style="width: 200px;float: left; margin-right: 20px; margin-bottom: 10px">
            <template slot="append">No. of LOPs</template>
          </el-input>
        </el-form-item>
        <el-form-item v-model="form.MainFlOn" label="Main floor on">
          <el-input style="width: 200px;float: left; margin-right: 20px; margin-bottom: 10px"/>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="LOP Indicator">
          <el-radio-group v-model="form.LOPIndicator">
            <el-radio label="Dot-matrix indicator" style="width: 120px; float:left; line-height: 35px;" @click.native.prevent="radioClick('Dot-matrix indicator', 'LOPIndicator')"/>
            <el-select v-model="form.LOPDotmatrix" placeholder="蓝色点阵VRM" style="width: 200px; float: left" :disabled="form.LOPIndicator !=='Dot-matrix indicator'">
              <el-option label="蓝色点阵VRM" value="蓝色点阵VRM"/>
              <el-option label="红色点阵VRM" value="红色点阵VRM"/>
            </el-select>
            <div style="clear:both;"/>
            <el-input v-model="form.BDBCneeded" style="width: 600px;">
              <template slot="append">Blue dot-matrix display SM.04VRM boards and connection cable needed</template>
            </el-input>
            <div style="clear:both;"/>
            <el-radio label="LCD indicator" style="width: 120px; float:left; line-height: 45px;" @click.native.prevent="radioClick('LCD indicator', 'LOPIndicator')"/>
            <el-select v-model="form.LOPLCD" placeholder="黑底白字SM.04VL16Y" style="width: 200px; float: left; line-height: 45px" :disabled="form.LOPIndicator !=='LCD indicator'">
              <el-option label="蓝底白字SM.04VL16Y" value="蓝底白字SM.04VL16Y"/>
              <el-option label="黑底白字SM.04VL16Y" value="黑底白字SM.04VL16Y"/>
            </el-select>
            <div style="clear:both;"/>
            <el-radio label="TFT Indicator 4.3" style="line-height: 28px; margin-bottom: 5px" @click.native.prevent="radioClick('TFT Indicator 4.3', 'LOPIndicator')"/>
            <el-radio label="Indicator to have OUT OF SERVICE message" style="line-height: 28px; margin-bottom: 5px" @click.native.prevent="radioClick('Indicator to have OUT OF SERVICE message', 'LOPIndicator')"/>
          </el-radio-group>
          <div style="clear:both;"/>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="LOP Button Options">
          <el-checkbox-group v-model="form.LOPBtnOptions">
            <el-checkbox label="Buttons to have Braille Markings"/>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="LOP Key Switch Options">
          <el-checkbox-group v-model="form.LOPKeySWOptions">
            <el-checkbox label="Parking lift Key Swich on Main Lobby" style="width: 40%;"/>
            <el-checkbox label="G楼1st LOP需要BA530钥匙开关控制楼层登记" style="width: 40%;"/>
            <el-checkbox label="1楼LOP也需要BA530钥匙开关控制楼层登记" style="width: 40%;"/>
            <el-checkbox label="所有LOP 需要BA530 钥匙开关(双位拔出), 控制楼层登记按钮通断" style="width: 40%;"/>
            <el-checkbox label="G楼2nd LOP 只配澳大利亚消防开关和BA530锁梯钥匙开关，无显示板，锁梯接1st LOP（配线5米）"/>
          </el-checkbox-group>
        </el-form-item>
        <div style="clear:both;">
          <el-form-item label="LOP Options">
            <el-checkbox-group v-model="form.LOPOptions">
              <el-checkbox label="LOP在门框上" style="width: 40%;"/>
              <el-checkbox label="LOP需要KLEEMANN logo" style="width: 40%;"/>
              <el-checkbox label="LOP远离井道，每个楼层LOP提供3米额外接线" style="width: 40%;"/>
              <el-checkbox label="门框无蓝线条，不需要提供LED 灯带供电，也无需401/402供电电缆" style="width: 40%;"/>
              <el-checkbox label="LOPs marking:DO NOT USE LIFT IF THERE IS A FIRE. The characters height need to be 10mm"/>
              <el-checkbox label="One more 24v power unit in the controller for the Blue line LEDs and also the connecting cables (401+/402-)"/>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </div>
      <div class="hstitle">Overdoor panels</div>
      <div class="horizontal-2">
        <el-form-item label="No. of panels with dot matrix display EHH130" label-width="350px">
          <el-input v-model="form.NOPwDMEHH130"/>
        </el-form-item>
        <el-form-item label="No. of panels with LCD display LCHL CD on G floor*" label-width="350px">
          <el-input v-model="form.NOPwLCDLCHLCDonG"/>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox-group v-model="form.ODPOptions">
            <el-checkbox label="STAINLESS STEEL SATIN/发纹不锈钢"/>
            <el-checkbox label="* Make sure the connection on the shaft communication HD cable is correct"/>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div class="hstitle">Monitoring</div>
      <div>
        <el-form-item label="">
          <el-checkbox-group v-model="form.MONTOptions">
            <el-checkbox label="Remote monitoring" style="width: 40%"/>
            <el-checkbox label="local monitoring in same building" style="width: 40%"/>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div style="text-align: right; margin: 20px auto">
        <el-form-item>
          <el-button type="primary" @click="saveSubmit">保存</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>

  export default {
    name: "SalesOrderNewPassengers",
    data() {
      return {
        showCOP2: false,
        formTitle: {
          liftType: "3",
        },
        form: {
          No: "",
          customerName: "",
          planDeliveryDate: "",
          projectName: "",
          finalDeliveryDate: "",
          orderDate: "",
          contact: "",
          clientContractNO: "",
          creatorName: "",
          deliveryPort: "",
          isDomesticProject: "",
          ProjectType: "",
          Socket: "",
          FBSwitch: false,
          FireBox: "",
          MTFireBox: "",
          ATARD: "",
          PztSwitch: false,
          DMLine: [],
          customerProperties: [
            {
              customerPropertyName: "国内项目",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ProjectType",
            },
            {
              customerPropertyName: "海外项目",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ProjectType",
            },
            {
              customerPropertyName: "通用插座",
              customerPropertyDesc: "通用插座",
              customerPropertyValue: 0,
              projectType: "Socket",
            },
            {
              customerPropertyName: "EU插座",
              customerPropertyDesc: "EU插座",
              customerPropertyValue: 0,
              projectType: "Socket",
            },
            {
              customerPropertyName: "英制插座",
              customerPropertyDesc: "英制插座",
              customerPropertyValue: 0,
              projectType: "Socket",
            },
            {
              customerPropertyName: "不需要消防盒",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "FireBox",
            },
            {
              customerPropertyName: "FS C300消防盒",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "FireBox",
            },
            {
              customerPropertyName: "需要透明玻璃的消防盒",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "FireBox",
            },
            {
              customerPropertyName: "钛黑发纹不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MTFireBox",
            },
            {
              customerPropertyName: "古铜发纹不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MTFireBox",
            },
            {
              customerPropertyName: "EF274/发纹/全英文/3MM",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MTFireBox",
            },
            {
              customerPropertyName: "Pizzato开关需要预接线",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "PztSwitch",
            },
            {
              customerPropertyName: "门机线T1,T2上需预接速普端子",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "DMLine",
            },
            {
              customerPropertyName: "西子门机，门机线T1,T2上需预接西子门机端子",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "DMLine",
            },
            {
              customerPropertyName: "Door machine connectors need to be pre-connected on T1,T2 branch cable",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "DMLine",
            },
            {
              customerPropertyName: "限速器MS，74要压端子，连接限速器线长度改为4米",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "SGTerminal",
            },
            {
              customerPropertyName: "减速开关和极限开关需要移动到轿顶，和ATLAS GIGAS同样设计！！",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "SwitchPosition",
            },
            {
              customerPropertyName: "无需提供塑料线槽，客户自备金属线槽",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "Trunking",
            },
            {
              customerPropertyName: "需要设置消防模式",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "FireMode",
            },
            {
              customerPropertyName: "需要澳洲消防程序",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "FireMode",
            },
            {
              customerPropertyName: "需要设置2个消防楼层，G楼为主消防楼层，1楼为第二消防楼层",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "FireMode",
            },
            {
              customerPropertyName: "LED井道灯",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ATSPOptions",
            },
            {
              customerPropertyName: "新井道灯（如果可用）",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ATSPOptions",
            },
            {
              customerPropertyName: "半自动门，无轿门",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ATSPOptions",
            },
            {
              customerPropertyName: "随行电缆长度安新非标计算",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ATSPOptions",
            },
            {
              customerPropertyName: "所有空气断路器必须是施耐德品牌！！",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ATSPOptions",
            },
            {
              customerPropertyName: "限速器测试和UPS电动松闸回路要重新设计",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ATSPOptions",
            },
            {
              customerPropertyName: "科莱曼提供 10724364 DEVICE 5HV-021  (TRIPHONIE) 2pcs",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ATSPOptions",
            },
            {
              customerPropertyName: "注意，此订单任何LOGO都需要用客户LOGO,不能体现任何KLEEMANN LOGO",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ATSPOptions",
            },
            {
              customerPropertyName: "No. of Lift",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "NoOfLift",
            },
            {
              customerPropertyName: "Lift Speed",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "LiftSpeed",
            },
            {
              customerPropertyName: "Lift Load",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "LiftLoad",
            },
            {
              customerPropertyName: "实际运行速度",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "ARSpeed",
            },
            {
              customerPropertyName: "Number of Lifts",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "NBLifts",
            },
            {
              customerPropertyName: "No. of Floors",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "NBFloors",
            },
            {
              customerPropertyName: "Number of Car Entrances",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "NBCarEntrances",
            },
            {
              customerPropertyName: "Number of Car Entrances",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "NBOpenings",
            },
            {
              customerPropertyName: "开前门",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "FrontOpening",
            },
            {
              customerPropertyName: "开后门",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "RearOpening",
            },
            {
              customerPropertyName: "前后双开门",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "AllOpening",
            },
            {
              customerPropertyName: "Main Lobby Marking",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "MLMarking",
            },
            {
              customerPropertyName: "1x230 V AC",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MPSupply",
            },
            {
              customerPropertyName: "3x380 V AC + 1x220 V AC",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MPSupply",
            },
            {
              customerPropertyName: "3x415 V AC + 1x240 V AC",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MPSupply",
            },
            {
              customerPropertyName: "Phase input",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "PhaseInput",
            },
            {
              customerPropertyName: "Hertz",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "Hertz",
            },
            {
              customerPropertyName: "Input wires  L1,L2,L3,N,PE",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "InputWires",
            },
            {
              customerPropertyName: "请提供，高耐压主板",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "EVOptions",
            },
            {
              customerPropertyName: "需要二次门锁回路",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "EVOptions",
            },
            {
              customerPropertyName: "控制柜内需要提供BMS干触点信号：电梯消防信号输出，主电源信号输出，正常/故障信号输出",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "EVOptions",
            },
            {
              customerPropertyName: "Serial Communication！",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "TypeofSystem",
            },
            {
              customerPropertyName: "Simplex",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "TypeofGroup",
            },
            {
              customerPropertyName: "Duplex",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "TypeofGroup",
            },
            {
              customerPropertyName: "Down Collective",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "TypeofControl",
            },
            {
              customerPropertyName: "Full Collective",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "TypeofControl",
            },
            {
              customerPropertyName: "Group Control - No of Lifts.",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "TypeofControl",
            },
            {
              customerPropertyName: "左侧",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MCDoor",
            },
            {
              customerPropertyName: "右侧",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MCDoor",
            },
            {
              customerPropertyName: "静音接触器",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "新款底坑维保装置",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "Small car top revision box",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "光幕需要接进安全回路",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "380Vac 3相输入",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "200VG分体控制柜",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "Inox Satin finishing",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "Kleemann specifications",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "轿厢有逃生窗，安全回路需要增加一个安全触点连接逃生窗电气开关！",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "底坑需要增加爬梯安全开关SSRL",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "Small control cabinet / stainless steel satin finishing",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "有松绳检测装置，请配置FR615安全开关并接好线",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "控制柜检修需要短接松绳检测装置",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "程序需要NSPE07KN09CN.17， 前后门一起控制时外呼仅开本侧门",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CCOptions",
            },
            {
              customerPropertyName: "Motor Model",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "MotorModel",
            },
            {
              customerPropertyName: "Sychron motor",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MotorType",
            },
            {
              customerPropertyName: "Asychron motor",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MotorType",
            },
            {
              customerPropertyName: "Gearless machine",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "GearType",
            },
            {
              customerPropertyName: "Geared machine",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "GearType",
            },
            {
              customerPropertyName: "With pre-wired motor power supply cable",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CableType",
            },
            {
              customerPropertyName: "With pre-wired motor thermal resistor TC cable",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "CableType",
            },
            {
              customerPropertyName: "Motor capacity",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "MotorCapacity",
            },
            {
              customerPropertyName: "Voltage",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "Voltage",
            },
            {
              customerPropertyName: "Rated rotation speed",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "RRSpeed",
            },
            {
              customerPropertyName: "Rated Current",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "RatedCurrent",
            },
            {
              customerPropertyName: "Activating Voltage",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "ACTVoltage",
            },
            {
              customerPropertyName: "Hold Voltage",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "HoldVoltage",
            },
            {
              customerPropertyName: "Type of Drive",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "TypeofDrive",
            },
            {
              customerPropertyName: "existing Tacho",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "SPfeedback",
            },
            {
              customerPropertyName: "existing motor encoder",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "SPfeedback",
            },
            {
              customerPropertyName: "existing encoder on governor",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "SPfeedback",
            },
            {
              customerPropertyName: "Encoder Heidenhein ΕCΝ1313",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "EncoderType",
            },
            {
              customerPropertyName: "Brand of Door Drive",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "BrandofDD",
            },
            {
              customerPropertyName: "AC with VVVF Regulator",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ACType",
            },
            {
              customerPropertyName: "Light Curtain",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "DoorSafety",
            },
            {
              customerPropertyName: "Light Ray",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "DoorSafety",
            },
            {
              customerPropertyName: "Door safety supply",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "DoorSafetySupply",
            },
            {
              customerPropertyName: "Mechanical Safety Edge",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MCSafetyEdge",
            },
            {
              customerPropertyName: "中分门",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "PCOptions",
            },
            {
              customerPropertyName: "新门机，需要更新门机接线",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "PCOptions",
            },
            {
              customerPropertyName: "不需要提供二次门锁开关，由福马特提供",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "PCOptions",
            },
            {
              customerPropertyName: "on top of the car",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ArrivalGong",
            },
            {
              customerPropertyName: "at every floor",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ArrivalGong",
            },
            {
              customerPropertyName: "4 stations",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "Intercom",
            },
            {
              customerPropertyName: "5 stations (20M cable needed)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "Intercom",
            },
            {
              customerPropertyName: "需要内部对讲",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "Intercom",
            },
            {
              customerPropertyName: "English",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "VoiceANNC",
            },
            {
              customerPropertyName: "Spanish",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "VoiceANNC",
            },
            {
              customerPropertyName: "泰语",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "VoiceANNC",
            },
            {
              customerPropertyName: "New UPS will be sent by KLEEMANN, ONLY UPS cable needed",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "AUTOEvacuation",
            },
            {
              customerPropertyName: "ARD HAA1001JJ1(无电池)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "IFARD",
            },
            {
              customerPropertyName: "ARD由KLEEMANN提供，STEP提供ARD连接控制柜的动力线缆",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "IFARD",
            },
            {
              customerPropertyName: "ARD HAA1001JJ1（有电池），发货前电池需拆除，单独放置在一个箱子内",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "IFARD",
            },
            {
              customerPropertyName: "Height from controller to top floor",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "HFCONTToTFloor",
            },
            {
              customerPropertyName: "Total Travel of Lift",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "TTravelLift",
            },
            {
              customerPropertyName: "The distance from Shaft to Controller",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "DistanceFSToCONT",
            },
            {
              customerPropertyName: "The distance from the Controller to the motor/brake",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "DistanceFCToMB",
            },
            {
              customerPropertyName: "Overhead Height",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "OverheadHeight",
            },
            {
              customerPropertyName: "Pit Depth",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "PitDepth",
            },
            {
              customerPropertyName: "The distance from hall call to shaft",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "DistFHCToShaft",
            },
            {
              customerPropertyName: "The distance from hall button to floor indicator",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "DistFHBToFIndicator",
            },
            {
              customerPropertyName: "Shaft width",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "ShaftWidth",
            },
            {
              customerPropertyName: "Shaft depth",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "ShaftDepth",
            },
            {
              customerPropertyName: "Duplex cable并联线",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "DPXCBPline",
            },
            {
              customerPropertyName: "应急拨号线缆需要屏蔽",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "WCOptions",
            },
            {
              customerPropertyName: "Extra travel Cable CAT5e",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "WCOptions",
            },
            {
              customerPropertyName: "随行电缆内需要2组电话线",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "WCOptions",
            },
            {
              customerPropertyName: "In traveling cable provide 4PCS CAT-7 cable",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "WCOptions",
            },
            {
              customerPropertyName: "随行电缆内需要配置CAT6（屏蔽） 电缆",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "WCOptions",
            },

            {
              customerPropertyName: "COP由BST提供，STEP提供相关电子部件",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "BSTCOP",
            },
            {
              customerPropertyName: "KCH LCD COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel",
            },
            {
              customerPropertyName: "KCH C300 COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel",
            },
            {
              customerPropertyName: "KCH 1000 SP Horizontal COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel",
            },
            {
              customerPropertyName: "KCH SM BA SP  (Surface mounted COP)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel",
            },
            {
              customerPropertyName: "KCH TFT COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel",
            },
            {
              customerPropertyName: "KCH LCD (COP 410)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel",
            },
            {
              customerPropertyName: "KCH TFT (COP410)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel",
            },
            {
              customerPropertyName: "KCH TSC Black COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel",
            },
            {
              customerPropertyName: "Blue line buttons KLH42R",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel",
            },
            {
              customerPropertyName: "Blue EB960 button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel",
            },
            {
              customerPropertyName: "Bicolor White-Blue button HA2300",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel",
            },
            {
              customerPropertyName: "Touch sensitive Square Blue button)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel",
            },
            {
              customerPropertyName: "White EB960 button(白光EB960按钮)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel",
            },
            {
              customerPropertyName: "blue line buttons KLH42Q（方按钮）",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel",
            },
            {
              customerPropertyName: "Blue EB218 button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel",
            },
            {
              customerPropertyName: "Blue EB680 button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel",
            },
            {
              customerPropertyName: "Stainless Steel Satin/发纹不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPSurface",
            },
            {
              customerPropertyName: "Stainless Steel Mirror/镜面不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPSurface",
            },
            {
              customerPropertyName: "Black glass panel-Touch sensitive",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPSurface",
            },
            {
              customerPropertyName: "Stainless Steel Rose Gold Mirror/玫瑰金镜面不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPSurface",
            },
            {
              customerPropertyName: "Stainless Steel Gold Mirror/钛金镜面不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPSurface",
            },
            {
              customerPropertyName: "Dot-matrix indicator",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPIndicator",
            },
            {
              customerPropertyName: "LCD indicator",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPIndicator",
            },
            {
              customerPropertyName: "TFT Indicator 7'",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPIndicator",
            },
            {
              customerPropertyName: "蓝色点阵VRM",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPDotmatrix1",
            },
            {
              customerPropertyName: "红色点阵VRM",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPDotmatrix1",
            },
            {
              customerPropertyName: "蓝底白字SM.04VL16Y",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPLCD1",
            },
            {
              customerPropertyName: "黑底白字SM.04VL16Y",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPLCD1",
            },
            {
              customerPropertyName: "Intercom",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ACOOptions",
            },
            {
              customerPropertyName: "Emergency light",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ACOOptions",
            },
            {
              customerPropertyName: "Autodialer in COP / Helpy 2w-v",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ACOOptions",
            },
            {
              customerPropertyName: "需要电话盒120*300*90mm",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ACOOptions",
            },
            {
              customerPropertyName: "Chinese & English Faceplate",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate",
            },
            {
              customerPropertyName: "English only Faceplate",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate",
            },
            {
              customerPropertyName: "Spanish only Faceplate",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate",
            },
            {
              customerPropertyName: "Nameplate to have Serial No.",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate",
            },
            {
              customerPropertyName: "Nameplate to have Client LOGO",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate",
            },
            {
              customerPropertyName: "Nameplate to have KLEEMANN LOGO",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate",
            },
            {
              customerPropertyName: "Nameplate to have installer Kleemann Elevators Australia Pty Ltd",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate",
            },
            {
              customerPropertyName: "按钮排布按照新非标",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "COP button arrangement to be the same as Greece COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "Buttons to have Braille Markings",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "蜂鸣板SM.09CW/O，配套双色按钮HA2300",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "需要开门保持，EB960 H按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "需要开门保持功能，KLH42R H 按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "禁烟按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "风扇按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "警铃按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "开关门按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "COP需要加风扇按钮,要加继电器板（kleemann提供），请留好安装螺柱和预接线（新尺寸）",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions",
            },
            {
              customerPropertyName: "需要开门保持功能，KLH42R 钥匙开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions",
            },
            {
              customerPropertyName: "需要消防钥匙开关，KLH42R 钥匙开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions",
            },
            {
              customerPropertyName: "需要DS钥匙开关，作为消防开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions",
            },
            {
              customerPropertyName: "COP需要一个BA530钥匙开关(双位拔出), 控制2个楼层按钮通断",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions",
            },
            {
              customerPropertyName: "澳大利亚消防开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions",
            },
            {
              customerPropertyName: "需要独立运行功能, BA530 钥匙开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions",
            },
            {
              customerPropertyName: "COP 有蓝线条",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPOption",
            },
            {
              customerPropertyName: "需要提供接副机的线 4*0.75mm，一根轿底（5m），一根轿顶（5m）。",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPOption",
            },
            {
              customerPropertyName: "COP由BST提供，STEP提供相关电子部件",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "BSTCOP2",
            },
            {
              customerPropertyName: "KCH LCD COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel2",
            },
            {
              customerPropertyName: "KCH C300 COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel2",
            },
            {
              customerPropertyName: "KCH 1000 SP Horizontal COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel2",
            },
            {
              customerPropertyName: "KCH SM BA SP  (Surface mounted COP)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel2",
            },
            {
              customerPropertyName: "KCH TFT COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel2",
            },
            {
              customerPropertyName: "KCH LCD (COP 410)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel2",
            },
            {
              customerPropertyName: "KCH TFT (COP410)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel2",
            },
            {
              customerPropertyName: "KCH TSC Black COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPModel2",
            },
            {
              customerPropertyName: "Blue line buttons KLH42R",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel2",
            },
            {
              customerPropertyName: "Blue EB960 button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel2",
            },
            {
              customerPropertyName: "Bicolor White-Blue button HA2300",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel2",
            },
            {
              customerPropertyName: "Touch sensitive Square Blue button)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel2",
            },
            {
              customerPropertyName: "White EB960 button(白光EB960按钮)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel2",
            },
            {
              customerPropertyName: "blue line buttons KLH42Q（方按钮）",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel2",
            },
            {
              customerPropertyName: "Blue EB218 button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel2",
            },
            {
              customerPropertyName: "Blue EB680 button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnModel2",
            },
            {
              customerPropertyName: "Stainless Steel Satin/发纹不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPSurface2",
            },
            {
              customerPropertyName: "Stainless Steel Mirror/镜面不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPSurface2",
            },
            {
              customerPropertyName: "Black glass panel-Touch sensitive",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPSurface2",
            },
            {
              customerPropertyName: "Stainless Steel Rose Gold Mirror/玫瑰金镜面不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPSurface2",
            },
            {
              customerPropertyName: "Stainless Steel Gold Mirror/钛金镜面不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPSurface2",
            },
            {
              customerPropertyName: "Dot-matrix indicator",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPIndicator2",
            },
            {
              customerPropertyName: "LCD indicator",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPIndicator2",
            },
            {
              customerPropertyName: "TFT Indicator 7'",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPIndicator2",
            },
            {
              customerPropertyName: "蓝色点阵VRM",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPDotmatrix2",
            },
            {
              customerPropertyName: "红色点阵VRM",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPDotmatrix2",
            },
            {
              customerPropertyName: "蓝底白字SM.04VL16Y",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPLCD2",
            },
            {
              customerPropertyName: "黑底白字SM.04VL16Y",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPLCD2",
            },
            {
              customerPropertyName: "Intercom",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ACOOptions2",
            },
            {
              customerPropertyName: "Emergency light",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ACOOptions2",
            },
            {
              customerPropertyName: "Autodialer in COP / Helpy 2w-v",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ACOOptions2",
            },
            {
              customerPropertyName: "需要电话盒120*300*90mm",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ACOOptions2",
            },
            {
              customerPropertyName: "Chinese & English Faceplate",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate2",
            },
            {
              customerPropertyName: "English only Faceplate",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate2",
            },
            {
              customerPropertyName: "Spanish only Faceplate",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate2",
            },
            {
              customerPropertyName: "Nameplate to have Serial No.",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate2",
            },
            {
              customerPropertyName: "Nameplate to have Client LOGO",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate2",
            },
            {
              customerPropertyName: "Nameplate to have KLEEMANN LOGO",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate2",
            },
            {
              customerPropertyName: "Nameplate to have installer Kleemann Elevators Australia Pty Ltd",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPNameplate2",
            },
            {
              customerPropertyName: "按钮排布按照新非标",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "COP button arrangement to be the same as Greece COP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "Buttons to have Braille Markings",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "蜂鸣板SM.09CW/O，配套双色按钮HA2300",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "需要开门保持，EB960 H按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "需要开门保持功能，KLH42R H 按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "禁烟按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "风扇按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "警铃按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "开关门按钮",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "COP需要加风扇按钮,要加继电器板（kleemann提供），请留好安装螺柱和预接线（新尺寸）",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPBtnOptions2",
            },
            {
              customerPropertyName: "需要开门保持功能，KLH42R 钥匙开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions2",
            },
            {
              customerPropertyName: "需要消防钥匙开关，KLH42R 钥匙开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions2",
            },
            {
              customerPropertyName: "需要DS钥匙开关，作为消防开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions2",
            },
            {
              customerPropertyName: "COP需要一个BA530钥匙开关(双位拔出), 控制2个楼层按钮通断",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions2",
            },
            {
              customerPropertyName: "澳大利亚消防开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions2",
            },
            {
              customerPropertyName: "需要独立运行功能, BA530 钥匙开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPKSOptions2",
            },
            {
              customerPropertyName: "COP 有蓝线条",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPOption2",
            },
            {
              customerPropertyName: "需要提供接副机的线 4*0.75mm，一根轿底（5m），一根轿顶（5m）。",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "COPOption2",
            },

            {
              customerPropertyName: "LOP由BST提供，STEP提供相关电子部件",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPSupplier",
            },
            {
              customerPropertyName: "Door post LOP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPModel",
            },
            {
              customerPropertyName: "LCH LCD LOP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPModel",
            },
            {
              customerPropertyName: "LCH C300 LOP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPModel",
            },
            {
              customerPropertyName: "LCH TFT LOP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPModel",
            },
            {
              customerPropertyName: "LCH  (EH130) LOP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPModel",
            },
            {
              customerPropertyName: "LCH TSL 102 LOP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPModel",
            },
            {
              customerPropertyName: "LCH SM2 LOP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPModel",
            },
            {
              customerPropertyName: "LCH C341 LOP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPModel",
            },
            {
              customerPropertyName: "LCH Duplex version (并联版EH130)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPModel",
            },
            {
              customerPropertyName: "AKL-AUS LOP",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPModel",
            },
            {
              customerPropertyName: "Blue line buttons KLH42R",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPBtnModel",
            },
            {
              customerPropertyName: "Blue EB960 button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPBtnModel",
            },
            {
              customerPropertyName: "Bicolor White-Blue button HA2300",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPBtnModel",
            },
            {
              customerPropertyName: "Touch sensitive Square Blue button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPBtnModel",
            },
            {
              customerPropertyName: "White EB960 button(白光EB960按钮)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPBtnModel",
            },
            {
              customerPropertyName: "blue line buttons KLH42Q（方按钮）",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPBtnModel",
            },
            {
              customerPropertyName: "Blue PB36 Button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPBtnModel",
            },
            {
              customerPropertyName: "Blue EB218 button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPBtnModel",
            },
            {
              customerPropertyName: "Blue EB680 button",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPBtnModel",
            },
            {
              customerPropertyName: "Stainless Steel Satin/发纹不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPSurface",
            },
            {
              customerPropertyName: "Stainless Steel Bronze Satin/古铜发纹不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPSurface",
            },
            {
              customerPropertyName: "Stainless Steel Mirror/镜面不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPSurface",
            },
            {
              customerPropertyName: "Stainless Steel Gold Mirror/钛金镜面不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPSurface",
            },
            {
              customerPropertyName: "Black glass panel-Touch sensitive",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPSurface",
            },
            {
              customerPropertyName: "Stainless Steel Rose Gold Mirror/玫瑰金镜面不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPSurface",
            },
            {
              customerPropertyName: "Stainless Steel Black Satin/ 钛黑发纹不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPSurface",
            },
            {
              customerPropertyName: "No. of LOPs",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "NoLOPs",
            },
            {
              customerPropertyName: "Main floor on",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "MainFlOn",
            },
            {
              customerPropertyName: "Dot-matrix indicator",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPIndicator",
            },
            {
              customerPropertyName: "LCD indicator",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPIndicator",
            },
            {
              customerPropertyName: "TFT Indicator 4.3'",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPIndicator",
            },
            {
              customerPropertyName: "蓝色点阵VRM",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPDotmatrix",
            },
            {
              customerPropertyName: "红色点阵VRM",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPDotmatrix",
            },
            {
              customerPropertyName: "蓝底白字SM.04VL16Y",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPLCD",
            },
            {
              customerPropertyName: "黑底白字SM.04VL16Y",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPLCD",
            },
            {
              customerPropertyName: "蓝底白字SM.04VL16XE",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPLCD",
            },
            {
              customerPropertyName: "Blue dot-matrix display SM.04VRM boards and connection cable needed",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "BDBCneeded",
            },
            {
              customerPropertyName: "Indicator to have OUT OF SERVICE message",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "IndicatorMsg",
            },
            {
              customerPropertyName: "Buttons to have Braille Markings",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPBtnOptions",
            },
            {
              customerPropertyName: "Parking lift Key Swich on Main Lobby",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPKeySWOptions",
            },
            {
              customerPropertyName: "G楼1st LOP需要BA530钥匙开关控制楼层登记",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPKeySWOptions",
            },
            {
              customerPropertyName: "1楼LOP也需要BA530钥匙开关控制楼层登记",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPKeySWOptions",
            },
            {
              customerPropertyName: "所有LOP 需要BA530 钥匙开关(双位拔出), 控制楼层登记按钮通断",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPKeySWOptions",
            },
            {
              customerPropertyName: "G楼2nd LOP 只配澳大利亚消防开关和BA530锁梯钥匙开关，无显示板，锁梯接1st LOP（配线5米）",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPKeySWOptions",
            },
            {
              customerPropertyName: "LOP在门框上",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPOptions",
            },
            {
              customerPropertyName: "LOP远离井道，每个楼层LOP提供3米额外接线",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPOptions",
            },
            {
              customerPropertyName: "LOP需要KLEEMANN logo",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPOptions",
            },
            {
              customerPropertyName: "门框无蓝线条，不需要提供LED 灯带供电，也无需401/402供电电缆",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPOptions",
            },
            {
              customerPropertyName: "One more 24v power unit in the controller for the Blue line LEDs and also the connecting cables (401+/402-)",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "LOPOptions",
            },
            {
              customerPropertyName: "No. of panels with dot matrix display EHH130",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "NOPwDMEHH130",
            },
            {
              customerPropertyName: "No. of panels with LCD display LCHL CD on G floor*",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "NOPwLCDLCHLCDonG",
            },
            {
              customerPropertyName: "STAINLESS STEEL SATIN/发纹不锈钢",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ODPOptions",
            },
            {
              customerPropertyName: "* Make sure the connection on the shaft communication HD cable is correct",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "ODPOptions",
            },
            {
              customerPropertyName: "Remote monitoring",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MONTOptions",
            },
            {
              customerPropertyName: "local monitoring in same building",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "MONTOptions",
            },
            {
              customerPropertyName: "折叠护栏开关数量",
              customerPropertyDesc: "",
              customerPropertyValue: "",
              projectType: "FBSwitchNum",
            },
            {
              customerPropertyName: "折叠护栏开关",
              customerPropertyDesc: "",
              customerPropertyValue: 0,
              projectType: "FBSwitch",
            },
          ],
          SGTerminal: "",
          SwitchPosition: "",
          Trunking: "",
          FireMode: "",
          ATSPOptions: [],
          NoOfLift: "",
          LiftLoad: "",
          NBLifts: "",
          NBFloors: "",
          LiftSpeed: "",
          ARSpeed: "",
          NBCarEntrances: "",
          NBOpenings: "",
          FrontOpening: "",
          RearOpening: "",
          AllOpening: "",
          MPSupply: "",
          PhaseInput: "",
          Hertz: "",
          EVOptions: [],
          MLMarking: "",
          InputWires: "",
          FQChanger: "",
          TypeofSystem: "",
          TypeofGroup: "",
          TypeofControl: "",
          SeismicSensor: "",
          SSLength: "",
          MCDoor: "",
          CCOptions: [],
          MotorModel: "",
          MotorType: "",
          GearType: "",
          CableType: [],
          MotorCapacity: "",
          Voltage: "",
          RRSpeed: "",
          RatedCurrent: "",
          MCOptions: [],
          ACTVoltage: "",
          TypeofDrive: "VVVF",
          HoldVoltage: "",
          SPfeedback: [],
          EncoderType: "",
          BrandofDD: "",
          ACType: "",
          DoorSafety: "",
          DoorSafetySupply: "",
          MCSafetyEdge: false,
          PCOptions: [],
          ArrivalGong: "",
          Intercom: [],
          VoiceANNC: "",
          AUTOEvacuation: "",
          IFARD: [],
          HFCONTToTFloor: "",
          TTravelLift: "",
          DistanceFSToCONT: "",
          DistanceFCToMB: "",
          OverheadHeight: "",
          PitDepth: "",
          DistFHCToShaft: "",
          DistFHBToFIndicator: "",
          FToFHeight: "",
          ShaftWidth: "",
          ShaftDepth: "",
          DPXCBPline: "",
          WCOptions: [],
          BSTCOP: "",
          BSTCOP2: "",
          COPModel: [],
          COPBtnModel: "",
          COPSurface: [],
          COPIndicator: "",
          ACOOptions: [],
          COPFaceplate: [],
          COPNameplate: [],
          COPBtnOptions: [],
          COPKSOptions: [],
          COPOption: [],
          LOPSupplier: "",
          LOPModel: "",
          LOPBtnModel: "",
          LOPSurface: [],
          NoLOPs: "",
          MainFlOn: "",
          LOPIndicator: "",
          LOPBtnOptions: [],
          LOPKeySWOptions: [],
          LOPOptions: [],
          NOPwDMEHH130: "",
          NOPwLCDLCHLCDonG: "",
          ODPOptions: [],
          MONTOptions: [],
          COPLCD1: "",
          COPLCD2: "",
          COPDotmatrix1: "",
          COPDotmatrix2: "",
          COPModel2: [],
          COPBtnModel2: "",
          COPSurface2: [],
          COPIndicator2: "",
          ACOOptions2: [],
          COPFaceplate2: [],
          COPNameplate2: [],
          COPBtnOptions2: [],
          COPKSOptions2: [],
          COPOption2: [],
          LOPLCD: "",
          LOPDotmatrix: "",
          BDBCneeded: "",
          resource: "",
          desc: "",
          floors: [
            {
              floorLevels:"",
              floorHeight:"",
            },
          ],
        },
        checkList: [""],
      };
    },
    methods: {
      saveSubmit() {
        this.$http
          .post("basic", "/sd/so/createCustomerSD",this.form)
          .then(resp => {
            console.log(resp);
            this.$message.success("保存成功");
          });
      },
      addItem() {
        this.form.floors.push({
          floorHeight: "",
          floorLevels: "",
        });
      },
      deleteItem(item,index) {
        this.form.floors.splice(index,1);
      },
      radioClick(e, formItem) {
        e == this.form[formItem] ? (this.form[formItem] = "") : (this.form[formItem] = e);
      },
    },
  };
</script>
<style scoped>
  .hbtitle{
    height: 70px;
    line-height: 12px;
    background: #eaf4fe;
    clear: both;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 12px;
    padding-top: 1px;
  }
  .hstitle{
    height: 35px;
    line-height: 35px;
    background: #f4f7fa;
    clear: both;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 5px;
  }

  .horizontal-2,.horizontal-3,.horizontal-4{
    height: 35px;
    line-height: 35px;
    margin: 10px auto;
  }
  .horizontal-2 >.el-form-item
  {
    width: 45%;
    float: left;
  }
  .horizontal-3 >.el-form-item
  {
    width: 30%;
    float: left;
  }

  .horizontal-4 >.el-form-item
  {
    width: 22%;
    float: left;
    margin-right: 1%;
  }
  .sw_center{
    width: 70%;
    text-align: center;
  }
  .sw_float{
    float: left;
  }
  .ww2{
    width: 45%;
    float: left;
  }
  .radio100{
    width: 100%;
    line-height: 28px;
    margin-bottom: 5px;
  }
  @media only screen and (max-width: 1400px) {
    .overwidth {
      max-width: 780px !important;
      height: 80px !important;
      word-break: normal !important;
      white-space: pre-wrap !important;
      word-wrap: break-word !important;
      overflow: hidden;
    }
  }
</style>


